import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import TextInput from '../../../components/form/TextInput';
import yup from '../../../libs/yup/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { inviteUser } from '../../../api/sportaloka-client';
import Swal from 'sweetalert2';

const defaultValues = {
  email: '',
  fullname: '',
  type: ''
};

const schema = yup.object().shape({
  email: yup
    .string()
    .label('Alamat email')
    .email('Format email salah')
    .required('${label} wajib diisi'),
  fullname: yup.string().label('Nama Lengkap').required('${label} wajib dipilih'),
  type: yup.string().label('Role').required('${label} wajib dipilih')
});

function CreateModal() {
  const [loading, setLoading] = useState(false);
  const form = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      await inviteUser(val);
      Swal.fire({
        title: 'Berhasil!',
        text: `Undangan telah dikirim ke email ${val.email}`,
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      document.getElementById('closeModalCreate').click();
      setLoading(false);
    } catch (error) {
      if (error.response.status === 409) {
        Swal.fire({
          title: 'Gagal!',
          text: `Email sudah terdaftar`,
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
        setLoading(false);
        return;
      }
      Swal.fire({
        title: 'Gagal!',
        text: `Periksa koneksi internet anda dan coba lagi`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    }
  };

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <div className="modal" tabIndex="-1" id="createModal">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Buat Pengguna</h5>
              <button
                id="closeModalCreate"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <Controller
                control={form.control}
                name="fullname"
                render={({ field: { onChange, onBlur, value } }) => (
                  <TextInput
                    disabled={loading}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    type="text"
                    isRequired={true}
                    label="Nama Lengkap"
                    isError={Boolean(form.formState.errors.fullname)}
                    errorMessage={
                      Boolean(form.formState.errors.fullname) &&
                      form.formState.errors.fullname.message
                    }
                  />
                )}
              />
              <Controller
                control={form.control}
                name="email"
                render={({ field: { onChange, onBlur, value } }) => (
                  <TextInput
                    disabled={loading}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    type="text"
                    isRequired={true}
                    label="Email"
                    isError={Boolean(form.formState.errors.email)}
                    errorMessage={
                      Boolean(form.formState.errors.email) && form.formState.errors.email.message
                    }
                  />
                )}
              />

              <Controller
                control={form.control}
                name="type"
                render={({ field: { onChange, onBlur, value } }) => (
                  <div className="form-group">
                    <label className="fw-600 mb-10">Role</label>
                    <select
                      className={`form-control ${Boolean(form.formState.errors.type) ? 'error' : ''}`}
                      value={value}
                      onChange={onChange}
                      onBlur={onBlur}>
                      <option value="">Pilih salah satu</option>
                      <option value="REGULAR_ADMIN">REGULAR_ADMIN</option>
                      <option value="MANAGEMENT_ADMIN">MANAGEMENT_ADMIN</option>
                    </select>
                    <span className="text-danger fw-400">
                      {Boolean(form.formState.errors.type) && form.formState.errors.type.message}
                    </span>
                  </div>
                )}
              />
            </div>
            <div className="modal-footer">
              <button
                disabled={loading}
                className="btn btn-primary bg-blue-1 rounded-1 fw-600 py-2 px-3">
                {loading ? 'Loading...' : 'Submit'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default CreateModal;
